import * as yup from 'yup';
import { BannerType } from '../types';

export const createBannerDialogSchema = yup.object().shape({
  content: yup.string().required().label('Content'),
  type: yup.mixed<BannerType>().oneOf(Object.values(BannerType)).required().label('Type'),
  isActive: yup.boolean().required().label('Active'),
  isClearable: yup.boolean().required().label('Clearable')
});

export const updateBannerDialogSchema = yup.object().shape({
  bannerId: yup.string().required().label('ID'),
  content: yup.string().required().label('Content'),
  type: yup.mixed<BannerType>().oneOf(Object.values(BannerType)).required().label('Type'),
  isActive: yup.boolean().required().label('Active'),
  isClearable: yup.boolean().required().label('Clearable')
});
